<style lang="postcss">
	.hidden-field {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.25rem;
	}
	.message {
		font-size: 0.75rem;
		font-weight: 600;
		opacity: 0.4;
		cursor: help;
	}
</style>

<script lang="ts">
	import Label from "$form/Fields/Shared/Label.svelte";
	import { tooltip } from "design/actions/tooltip";
	export let field: FieldDisplay & { type: "Hidden" };
</script>

<div class="hidden-field">
	<Label html="{field.labelHTMLComputed}" />
	<span
		class="message"
		use:tooltip="{{
			content:
				'This will be hidden from the user on a live form, but will be sent to the server.'
		}}">ⓘ</span>
</div>
<div style="opacity: 0.4" class="field-input-cover">
	{field.valueComputed || "..."}
</div>
